import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation, useApolloClient } from "react-apollo";

import { Title, Fieldset, Field, Control, Button } from "rbx";

import VehicleInspectionMasterForm from "./VehicleInspectionMasterForm";
import {
  CREATE_VEHICLE_INSPECTION_MASTER_MUTATION,
  ALL_VEHICLE_INSPECTIONS_MASTER_QUERY
} from "../../graphql/Vehicles/Vehicles.graphql";
import { ourToast as toast } from "../../utils";

const INITIAL_STATE = {
  InspectionTypeRecIdRef: "",
  MileageInterval: "",
  DaysInterval: "",
  Active: true
};

function AddVehicleInspectionMasterForm({ id, onComplete }) {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE
  });
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };

  const [createVehicleInspectionMaster] = useMutation(
    CREATE_VEHICLE_INSPECTION_MASTER_MUTATION,
    {
      refetchQueries: ["ALL_VEHICLE_INSPECTIONS_MASTER_QUERY"]
    }
  );

  const handleSave = async e => {
    e.preventDefault();
    try {
      setLoading(true);
      const {
        data: { VehicleInspectionsMasters }
      } = await client.query({
        query: ALL_VEHICLE_INSPECTIONS_MASTER_QUERY,
        variables: {
          where: {
            InspectionTypeRecIdRef: parseInt(inputs.InspectionTypeRecIdRef),
            VehicleRecIdRef: parseInt(id)
          },
          first: 1
        },
        fetchPolicy: "network-only"
      });
      if (VehicleInspectionsMasters.length) {
        toast.error(
          "Already exist one record for this Vehicle Inspection Master."
        );
      } else {
        await createVehicleInspectionMaster({
          variables: {
            data: {
              ...inputs,
              VehicleRecIdRef: parseInt(id),
              InspectionTypeRecIdRef: parseInt(inputs.InspectionTypeRecIdRef),
              Active: inputs.Active || inputs.Active === "on",
              MileageInterval: parseInt(inputs.MileageInterval),
              DaysInterval: parseInt(inputs.DaysInterval)
            }
          }
        });
        toast.success("Vehicle Inspection Master created successfully.");
        onComplete();
      }
    } catch (err) {
      toast.error("Error creating Vehicle Inspection Master.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="add-vehicle-inspection-form">
      <Title>Add Vehicle Inspection Master</Title>
      <form id="add-vehicle-inspection-form" onSubmit={handleSave}>
        <Fieldset disabled={loading}>
          <VehicleInspectionMasterForm
            inputs={inputs}
            onChange={handleChange}
          />
          <hr />
          <Field kind="group">
            <Control>
              <Button
                color="primary"
                state={loading ? "loading" : ""}
                type="submit"
              >
                Submit
              </Button>
            </Control>
            <Control>
              <Button disabled={loading} type="button" onClick={onComplete}>
                Cancel
              </Button>
            </Control>
          </Field>
        </Fieldset>
      </form>
    </div>
  );
}

AddVehicleInspectionMasterForm.propTypes = {
  id: PropTypes.number.isRequired,
  onComplete: PropTypes.func
};

export default AddVehicleInspectionMasterForm;
